import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import replaceAll from "string.prototype.replaceall";

import {
    Product,
    Discount,
    DiscountValue,
    OffText,
    WrapperProductImage,
    Content,
    Wrapp,
    Title,
    Brand,
    Price,
    AnnouncedBy
} from "./styles";

import handleURLParams from '../../../../utils/handleURLParams';

import ProductPlaceholder from "../../../../assets/images/placeholders/product-458x406.png";

function limitTitle(text = "", maxLength = 6, limit = 6) {
    let setText = "";
    const textArray = [];
    const textToArray = text.split(" ");

    if (textToArray.length > maxLength) {
        const sl = textToArray.slice(0, limit);
        textArray.push(sl);
        const joinToStr = textArray.join("|");
        const formatText = replaceAll(joinToStr, ",", " ");

        setText += formatText;

    } else {
        setText += text;
    }

    return setText || "...";
}
export const ProductBox = (
    {
        productId,
        productType,
        discountValue,
        image,
        productTitle,
        productBrand,
        productPrice,
        gridMargin,
        priceColor,
        announcedBy,
        company
    }
) => {
    const history = useHistory();
    const location = useLocation();

    const announcedByType = {
        atacadao: "Atacadão",
        carrefour: "Carrefour",
        parceiro: "Parceiro"
    };

    const handleOfferSearch = ({ product, type }) => {
        handleURLParams({
            listOfKeyValues: [
                { key: 'productId', value: product },
                { key: 'limit', value: 8 }
            ],
            location: location,
            history: history
        });
        return history.push({ pathname: type === 'desconto' || type === 'divulgacao' ? '/oferta' : '/resgatar', search: history.location.search });
    }

    return (
        <Product margin={gridMargin}>
            <a href='#!' onClick={() => handleOfferSearch({ product: productId, type: productType })}>
                
                {announcedBy && (
                    <AnnouncedBy company={company} typePartner={announcedBy === "parceiro"}>
                        Oferta {announcedByType[announcedBy]}
                    </AnnouncedBy>
                )}

                {discountValue && (
                    <Discount>
                        <DiscountValue>
                            {discountValue || 0}%
                        </DiscountValue>
                        <OffText>off</OffText>
                    </Discount>
                )}
                <WrapperProductImage>
                    <div className="WrapAnchorPicture">
                        <div className="AnchorPicture">
                            <div className="WrapPicture">
                                <picture>
                                    <img
                                        onError={(e) => e.target.src = ProductPlaceholder}
                                        src={image}
                                        alt={productTitle}
                                    />
                                </picture>
                            </div>
                        </div>
                    </div>
                </WrapperProductImage>

                <Content>
                    <Wrapp>
                        <Title>
                            {productTitle ? limitTitle(productTitle, 6, 6) : "..."}
                        </Title>

                        {productBrand && (
                            <Brand> {productBrand} </Brand>
                        )}

                    </Wrapp>

                    <Price priceColor={priceColor}>
                        {/* {limitTitle(productPrice, 4, 6)} */}
                        {productPrice}
                    </Price>
                </Content>
            </a>
        </Product>
    )
}

export default ProductBox;